import ICardFamiliareProps from "components/CardFamiliare/ICardFamiliareProps";

import { FaCheckCircle, FaUserCircle } from "react-icons/fa";

import "./CardFamiliare.css";
import moment from "moment";
import { Enhanced } from "utils/ReactUtils";

const CardFamiliare: React.FC<ICardFamiliareProps> = ({ familiare, selected, OnClick, showAddressDetails, useAvatar = false, showLegame = true,t }) => {
	const OnCardSelected = () => {
		if (OnClick) OnClick(familiare.Matricola);
	};


	const isResidenzaValid = () => {
		return (
			!(familiare.IndirizzoResidenza?.isNullOrWhiteSpaces() ?? true) ||
			!(familiare.IndirizzoResidenzaDett?.isNullOrWhiteSpaces() ?? true) ||
			!(familiare.CapResidenza?.isNullOrWhiteSpaces() ?? true) ||
			!(familiare.ComuneResidenza?.isNullOrWhiteSpaces() ?? true)
		);
	};
	const isDomicilioValid = () => {
		return (
			!(familiare.IndirizzoDomicilio?.isNullOrWhiteSpaces() ?? true) ||
			!(familiare.IndirizzoDomicilioDett?.isNullOrWhiteSpaces() ?? true) ||
			!(familiare.CapDomicilio?.isNullOrWhiteSpaces() ?? true) ||
			!(familiare.ComuneDomicilio?.isNullOrWhiteSpaces() ?? true)
		);
	};

	return (
		<div
			className={`card-familiare${selected && selected.Matricola === familiare.Matricola ? " card-selected" : ""} ${
				OnClick !== undefined ? " selectable" : " not-selectable"
			}`}
			onClick={OnCardSelected}
			onKeyDown={(event) =>{ if (event.key === "Enter") {OnCardSelected()}}}
			role="button"
			tabIndex={Number(familiare.Matricola)||-1 }
		>
			<div className="avatar">
				{!useAvatar ? (
					<FaUserCircle size={"100%"} style={{ color: "grey" }}></FaUserCircle>
				) : (
					<img
						style={{ borderRadius: "50%" }}
						alt={`img-${familiare.Cognome}.${familiare.Nome}`}
						src={`https://eu.ui-avatars.com/api/?name=${familiare.Cognome}+${familiare.Nome}`}
					/>
				)}
			</div>
			<div className="info">
				<div className="nome-familiare">
					<span>
						{familiare.Cognome} {familiare.Nome}
					</span>
				</div>
				<div className="details">
					<span>
						{t("cardFamiliare.nato")} {moment(familiare.DataNascita).format("L")}
					</span>
					<span>
						{t("cardFamiliare.cf")} {familiare.CodiceFiscale}
					</span>
				</div>
				{showLegame && familiare.LegameUtente && (
					<div className="legame">
						<span>
							{t("cardFamiliare.legame")} {familiare.LegameUtente}
						</span>
					</div>
				)}

				{isDomicilioValid() && (
					<div className="indirizzo-domicilio">
						<span>
							{t("cardFamiliare.domicilio")}
							<br />
							{`${
								familiare.IndirizzoDomicilio || familiare.IndirizzoDomicilioDett
									? (familiare.IndirizzoDomicilio ?? "") + " " + (familiare.IndirizzoDomicilioDett ?? "") + ", "
									: ""
							}${familiare.CapDomicilio ?? ""},${familiare.ComuneDomicilio ?? ""}`}
							<br />
							{familiare.TelDomicilio}
							<br />
						</span>
					</div>
				)}
				{isResidenzaValid() && showAddressDetails && (
					<div className="indirizzo-residenza">
						<span>
							{t("cardFamiliare.residenza")}
							<br />
							{`${
								familiare.IndirizzoResidenza || familiare.IndirizzoResidenzaDett
									? (familiare.IndirizzoResidenza ?? "") + " " + (familiare.IndirizzoResidenzaDett ?? "") + ", "
									: ""
							}${familiare.CapResidenza ?? ""},${familiare.ComuneResidenza ?? ""}`}
							<br />
							<br />
							{familiare.TelResidenza}
						</span>
					</div>
				)}
			</div>

			<div className="selected-icon-box">
				{selected && selected.Matricola === familiare.Matricola ? (
					<FaCheckCircle className="icon-selected" />
				) : (
					<FaCheckCircle className="icon-not-selected" />
				)}
			</div>
		</div>
	);
};

export default Enhanced( CardFamiliare,{componentNamespace:"CardFamiliare"});
